import React, { Component } from 'react';
import Head from 'next/head'
import { Header, Footer, News, PageWrapper } from '../components'
import { format } from 'date-fns'
import { fetchPost } from '../api/news'

class NewsArticle extends Component {
  static async getInitialProps({ req, query, props }) {
    const postPromise = fetchPost(query.id);
    return {
        post: await postPromise,
        organisationId: props.organisationId
    }
  }

  render() {
    const { post, organisationId, organisation, pages } = this.props;
    let imageSrc="https://brha.co/static/photo.png"

    if (post) {
      const imageMatch = post.html.match(/<img[^>]+src="([^">]+)"/)

      if (imageMatch) {
        imageSrc = imageMatch[1] ;
      }
    }
    return (
      <div className={`u-grid u-grid--basic u-grid-${organisationId}`}>
        <Head>
          <title>{`${organisation.name} | News | `} {post.headline}</title>
          <meta property="og:title" content={`BRHA | News | ${post.headline}`} />
          <meta property="og:description" content={post.headline}/>
          <meta property="og:image" content={imageSrc} />
        </Head>
        <Header region={organisation.name} regionId={organisation.id} pages={pages}/>
        <div className="u-grid__main">
          <News article={post} key={post.id} />
        </div>
        <Footer regionId={organisation.id}/>
      </div>
    )
  }

}
export default PageWrapper(NewsArticle)
